var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"kindTab"},_vm._l((_vm.tabData),function(item,index){return _c('li',{key:index,class:{
      active: _vm.active === index,
    },on:{"click":function($event){return _vm.itemBtn(item, index)}}},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(item.title)+" ")]),(_vm.active !== index)?_c('img',{attrs:{"src":item.url,"alt":"","srcset":""}}):_c('img',{attrs:{"src":item.activeUrl,"alt":"","srcset":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }